import { RxCross2 } from 'react-icons/rx';
import Image from 'next/image';
import { ShopifyCartProps } from '#/globalTypes';
import InitiationFee from './InitiationFee';
interface CartItemProps {
  item: ShopifyCartProps;
  removeItem: (slug: string) => void;
}
export default function CartItems(props: CartItemProps) {
  const { item, removeItem } = props;

  return (
    <div
      className={
        'w-full h-auto flex flex-col mb-4  rounded-lg border-2 border-gray-200 text-[#5B5B5B]'
      }
      data-testid={'cart-items'}
    >
      <div className={'w-full hidden xl:flex flex-row  justify-between p-4'}>
        <div className={'w-[120px] items-start justify-start'}>
          <Image
            src={item.src}
            alt={'Purchased item'}
            width={100}
            height={100}
          />
        </div>
        <div className={'w-full flex flex-col'}>
          <div className={'w-full flex flex-row justify-between items-start'}>
            <div className={'flex flex-col'}>
              <p className={'font-medium mb-1'}>{item.productName} Rental</p>
              <div
                className={
                  'flex flex-row items-center justify-between w-48 mb-1'
                }
              >
                <p className={'text-sm'}>{item.carrier}</p>
                <div className={'w-0.5 h-6 bg-flexThemeBlue my-2'}></div>
                <p className={'text-sm'}>{item.color}</p>
                <div className={'w-0.5 h-6 bg-flexThemeBlue my-2'}></div>
                <p className={'text-sm'}>{item.storageSpace}</p>
              </div>
            </div>
            <div className={'flex flex-row items-center'}>
              <p className={'text-sm'}>Quantity</p>
              <select
                className={'ml-2 w-16 h-8 bg-white border-2 border-gray-200'}
                data-testid={'select-element'}
                data-cy={'select-element'}
                disabled
              >
                <option
                  key={1}
                  value={1}
                  data-cy={'quantity-num'}
                  selected={item.quantity === 1}
                >
                  {1}
                </option>
              </select>
            </div>
          </div>
          <div className={'indent-1'}>
            <ul className={'list-disc indent-1'}>
              <li className={'text-sm font-light'}>
                Pay per month for 12 months, cancel anytime afterwards through
                your online account.
              </li>
              <li className={'text-sm font-light'}>
                First month due at checkout.
              </li>
              <li className={'text-sm font-light'}>
                Eligible for refund within 30 days of purchase.
              </li>
            </ul>
          </div>
        </div>
        <div className={'w-[120px] flex flex-col justify-between items-end'}>
          <div className={'flex flex-col items-start'}>
            <p
              className={'text-flexThemeBlue text-lg mb-1'}
              data-testid={'total-price'}
              data-cy={'total-price'}
            >
              ${item?.rentingPrice}
            </p>
            <p className={'text-sm font-light'}>per month</p>
          </div>
          <button
            onClick={() => removeItem(item.productSlug)}
            className={'text-primary flex flex-row items-center'}
            data-cy={'remove-item-button'}
            data-tracking-id="remove-cart"
          >
            <span className={'mr-2 text-primary'}>
              <RxCross2 size={20} />
            </span>
            Remove
          </button>
        </div>
      </div>
      <div className={'w-full flex xl:hidden flex-col justify-between p-4'}>
        <div className={'w-full flex flex-row '}>
          <div className={'items-start justify-start'}>
            <Image
              src={item.src}
              alt={'Purchased item'}
              width={120}
              height={100}
            />
          </div>
          <div
            className={'flex flex-col w-full ml-2 items-start justify-between'}
          >
            <p className={'font-medium mb-1'}>{item.productName} Rental</p>
            <div
              className={
                'flex flex-row items-center justify-between flex-wrap mb-1'
              }
            >
              <p className={'text-sm'}>{item.carrier}</p>
              <div className={'w-0.5 h-6 bg-flexThemeBlue mx-2'}></div>
              <p className={'text-sm'}>{item.color}</p>
              <div className={'w-0.5 h-6 bg-flexThemeBlue mx-2'}></div>
              <p className={'text-sm'}>{item.storageSpace}</p>
            </div>
            <div
              className={
                'my-2 w-full flex flex-row items-start justify-between'
              }
            >
              <div className={'flex flex-row items-center'}>
                <p className={'text-sm text-bgDarkGrey'}>Qty</p>
                <select
                  className={'ml-2 w-16 h-8 bg-white border-2 border-gray-200'}
                  data-testid={'select-element'}
                  data-cy={'select-element'}
                  disabled
                >
                  <option
                    key={1}
                    value={1}
                    data-cy={'quantity-num'}
                    selected={item.quantity === 1}
                  >
                    {1}
                  </option>
                </select>
              </div>
              <div className={'flex flex-col items-end justify-end'}>
                <p
                  className={'text-flexThemeBlue text-lg mb-1'}
                  data-testid={'total-price'}
                >
                  ${item.rentingPrice}
                </p>
                <p className={'text-sm font-light'}>per month</p>
              </div>
            </div>
          </div>
        </div>
        <ul className={'list-inside w-full px-5'}>
          <li className="relative before:inline-block before:content-['\2022'] before:mr-2 text-sm font-light">
            Pay per month for 12 months, cancel anytime afterwards through your
            online account.
          </li>
          <li className="relative before:inline-block before:content-['\2022'] before:mr-2 text-sm font-light">
            First month due at checkout.
          </li>
          <li className="relative before:inline-block before:content-['\2022'] before:mr-2 text-sm font-light">
            Eligible for refund within 30 days of purchase.
          </li>
          <li className="relative before:inline-block before:content-['\2022'] before:mr-2 text-sm font-light">
            Your recurring rental payment will be billed 1 month from your
            rental start date
          </li>
        </ul>
        <div className={'w-full flex flex-row justify-end items-end my-2'}>
          <button
            onClick={() => removeItem(item.productSlug)}
            className={'text-primary flex flex-row items-center'}
            data-cy={'remove-item-button'}
            data-tracking-id="remove-cart"
          >
            <span className={'mr-2 text-primary'}>
              <RxCross2 size={20} />
            </span>
            Remove
          </button>
        </div>
      </div>
      <InitiationFee />
    </div>
  );
}
